import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _dc0fd1f2 = () => interopDefault(import('../pages/mailbox.vue' /* webpackChunkName: "pages/mailbox" */))
const _92ec2fee = () => interopDefault(import('../pages/my-account.vue' /* webpackChunkName: "pages/my-account" */))
const _fd3ef868 = () => interopDefault(import('../pages/my-account/index.vue' /* webpackChunkName: "pages/my-account/index" */))
const _4c3b2128 = () => interopDefault(import('../pages/my-account/basic.vue' /* webpackChunkName: "pages/my-account/basic" */))
const _c6c150cc = () => interopDefault(import('../pages/my-account/contact.vue' /* webpackChunkName: "pages/my-account/contact" */))
const _2db74776 = () => interopDefault(import('../pages/my-account/credentials.vue' /* webpackChunkName: "pages/my-account/credentials" */))
const _2e3ba7a0 = () => interopDefault(import('../pages/my-account/data.vue' /* webpackChunkName: "pages/my-account/data" */))
const _6255e6a2 = () => interopDefault(import('../pages/my-account/education.vue' /* webpackChunkName: "pages/my-account/education" */))
const _537c8b4c = () => interopDefault(import('../pages/my-account/membership.vue' /* webpackChunkName: "pages/my-account/membership" */))
const _68d1e1a6 = () => interopDefault(import('../pages/my-account/recurrence.vue' /* webpackChunkName: "pages/my-account/recurrence" */))
const _707acfce = () => interopDefault(import('../pages/scholarships.vue' /* webpackChunkName: "pages/scholarships" */))
const _617d76c2 = () => interopDefault(import('../pages/scholarships/cardList.vue' /* webpackChunkName: "pages/scholarships/cardList" */))
const _3c486dda = () => interopDefault(import('../pages/scholarships/dashboard.vue' /* webpackChunkName: "pages/scholarships/dashboard" */))
const _7866d0fe = () => interopDefault(import('../pages/scholarships/details.vue' /* webpackChunkName: "pages/scholarships/details" */))
const _24baa39a = () => interopDefault(import('../pages/scholarships/recommended.vue' /* webpackChunkName: "pages/scholarships/recommended" */))
const _46f76c24 = () => interopDefault(import('../pages/scholarships/resources.vue' /* webpackChunkName: "pages/scholarships/resources" */))
const _b110716c = () => interopDefault(import('../pages/scholarships/sentRequirement.vue' /* webpackChunkName: "pages/scholarships/sentRequirement" */))
const _b8e66140 = () => interopDefault(import('../pages/scholarships/debug/goal.vue' /* webpackChunkName: "pages/scholarships/debug/goal" */))
const _3f11a212 = () => interopDefault(import('../pages/textEditor.vue' /* webpackChunkName: "pages/textEditor" */))
const _36605e44 = () => interopDefault(import('../pages/debug/modal.vue' /* webpackChunkName: "pages/debug/modal" */))
const _c3f0057c = () => interopDefault(import('../pages/debug/modalWithSwiper.vue' /* webpackChunkName: "pages/debug/modalWithSwiper" */))
const _0a167f71 = () => interopDefault(import('../pages/debug/swiper.vue' /* webpackChunkName: "pages/debug/swiper" */))
const _5d179bb8 = () => interopDefault(import('../pages/debug/winner.vue' /* webpackChunkName: "pages/debug/winner" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/mailbox",
    component: _dc0fd1f2,
    name: "mailbox"
  }, {
    path: "/my-account",
    component: _92ec2fee,
    children: [{
      path: "",
      component: _fd3ef868,
      name: "my-account"
    }, {
      path: "basic",
      component: _4c3b2128,
      name: "my-account-basic"
    }, {
      path: "contact",
      component: _c6c150cc,
      name: "my-account-contact"
    }, {
      path: "credentials",
      component: _2db74776,
      name: "my-account-credentials"
    }, {
      path: "data",
      component: _2e3ba7a0,
      name: "my-account-data"
    }, {
      path: "education",
      component: _6255e6a2,
      name: "my-account-education"
    }, {
      path: "membership",
      component: _537c8b4c,
      name: "my-account-membership"
    }, {
      path: "recurrence",
      component: _68d1e1a6,
      name: "my-account-recurrence"
    }]
  }, {
    path: "/scholarships",
    component: _707acfce,
    name: "scholarships",
    children: [{
      path: "cardList",
      component: _617d76c2,
      name: "scholarships-cardList"
    }, {
      path: "dashboard",
      component: _3c486dda,
      name: "scholarships-dashboard"
    }, {
      path: "details",
      component: _7866d0fe,
      name: "scholarships-details"
    }, {
      path: "recommended",
      component: _24baa39a,
      name: "scholarships-recommended"
    }, {
      path: "resources",
      component: _46f76c24,
      name: "scholarships-resources"
    }, {
      path: "sentRequirement",
      component: _b110716c,
      name: "scholarships-sentRequirement"
    }, {
      path: "debug/goal",
      component: _b8e66140,
      name: "scholarships-debug-goal"
    }]
  }, {
    path: "/textEditor",
    component: _3f11a212,
    name: "textEditor"
  }, {
    path: "/debug/modal",
    component: _36605e44,
    name: "debug-modal"
  }, {
    path: "/debug/modalWithSwiper",
    component: _c3f0057c,
    name: "debug-modalWithSwiper"
  }, {
    path: "/debug/swiper",
    component: _0a167f71,
    name: "debug-swiper"
  }, {
    path: "/debug/winner",
    component: _5d179bb8,
    name: "debug-winner"
  }, {
    path: "/scholarships",
    component: _707acfce,
    children: [{
      path: "dashboard",
      component: _3c486dda
    }, {
      path: "recommended",
      component: _24baa39a
    }, {
      path: "submitted",
      redirect: {"path":"submitted/active"}
    }, {
      path: "resources",
      component: _46f76c24
    }, {
      path: ":tabName/:cardId(\\d+)",
      component: _7866d0fe,
      props: true
    }, {
      path: ":tabName/:subTabName?",
      component: _617d76c2
    }, {
      path: ":tabName/notif/success",
      component: _b110716c
    }, {
      path: "submitted/:id(\\d+)/success",
      component: _b110716c,
      props: true
    }]
  }, {
    path: "/scholarships/:tabName/:cardId(\\d+)/:requirementId(\\d+)",
    component: _3f11a212,
    props: true,
    name: "text-editor"
  }, {
    path: "/",
    redirect: {"path":"scholarships"},
    name: "home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
